// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"4ee3493b","453":"8aa06964"}[chunkId] + ".chunk.js";
};